import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from './redux/actions';
import AuthenticatedPage from '../common/AuthenticatedPage.jsx';
import {IndexLink, Link} from 'react-router';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import UserUtils from '../utils/UserUtils';

class Profile extends React.Component {
  componentDidMount() {
    this.props.getProfile();
  }

  render() {
    const {profile} = this.props.profile;
    if (!profile) return null;

    return (
      <div className="ba-profile">
        <Helmet title="Profile"
                meta={[{property: 'og:image', content: UserUtils.getSmallImageUrl(profile)}]}/>
        <div className="row row-wide">
          <div className="small-12 columns text-center">
            <ul className="ba-tabs">
              <li className="ba-tab">
                <IndexLink to="/profile" activeClassName="active">Personal Information</IndexLink>
              </li>
              <li className="ba-tab">
                <Link to="/profile/security" activeClassName="active">Sign-in & security</Link>
              </li>
            </ul>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.profile
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

Profile.displayName = 'Profile';
Profile.contextTypes = {
  router: PropTypes.object.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedPage(Profile));



// WEBPACK FOOTER //
// ./shared/profile/Profile.jsx